import React, { useEffect, useState } from "react";
import styles from "./Home.module.css";
import SearchBar from "../../Components/Home/SearchBar/SearchBar";
import StoryList from "../../Components/Home/StoryList/StoryList";
import { fetchYourStories } from "../../config/data";
import Pagination from "../../Components/Common/Pagination/Pagination"; // Assume this is a pagination component you have

const MyStory = () => {
  const [stories, setStories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState('public');
  const [storiesPerPage] = useState(10); // Adjust based on your preference

  useEffect(() => {
    const loadData = async () => {
      const data = await fetchYourStories();
      setStories(data);
    };
    loadData();
  }, []);

  // Get current stories
  const indexOfLastStory = currentPage * storiesPerPage;
  const indexOfFirstStory = indexOfLastStory - storiesPerPage;
  const currentStories = stories.slice(indexOfFirstStory, indexOfLastStory);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Create these as separate components
  const PublicStories = () => {
    return (
      <div className="stories-list">
        {/* Your stories list component */}
        <p>Public Stories will appear here</p>
      </div>
    );
  };

  const PrivateStories = () => {
    return (
      <div className="stories-list">
        {/* Your stories list component */}
        <p>Private Stories will appear here</p>
      </div>
    );
  };

  return (
    <div className={styles.home}>
      <div className="stories-tabs">
        <button 
          className={`tab-btn ${activeTab === 'public' ? 'active' : ''}`}
          onClick={() => setActiveTab('public')}
        >
          Public Stories
        </button>
        <button 
          className={`tab-btn ${activeTab === 'private' ? 'active' : ''}`}
          onClick={() => setActiveTab('private')}
        >
          Private Stories
        </button>
      </div>

      <div className="stories-content">
        {activeTab === 'public' ? (
          <PublicStories />
        ) : (
          <PrivateStories />
        )}
      </div>

      <SearchBar />
      
      {currentStories.length ? (
        <>
        
          <StoryList stories={currentStories} />
          <Pagination
            itemsPerPage={storiesPerPage}
            totalItems={stories.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </>
      ) : (
        <p>No stories found</p>
      )}
    </div>
  );
};

export default MyStory;
